import {Page} from 'components/system/Page'
import {useConfirmOrderMutation} from 'hooks/ventrata/useConfirmOrderMutation'
import {useOrderPath} from 'providers/EnvironmentProvider'
import {useOrderDetails} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useResultSetter} from 'providers/ResultProvider'
import {useEffect, useState} from 'react'
import {singleCall} from 'utils/singleCall'

export const View = () => {
  const order = OrderProvider.useOrder('optional')
  const orderIntent = useOrderDetails()
  const setOrder = OrderProvider.useOrderSetter()
  const setResult = useResultSetter()
  const confirmOrderMutation = useConfirmOrderMutation()
  const confirmOrderMutate = confirmOrderMutation.mutate
  const orderPath = useOrderPath()
  const [delayed, setDelayed] = useState<boolean>(false)
  const [tryAgain, setTryAgain] = useState<boolean>(false)

  useEffect(() => {
    if (!order) {
      return
    }

    setTimeout(() => {
      setDelayed(true)
    }, 5000)

    setTimeout(() => {
      setTryAgain(true)
    }, 15000)

    singleCall('confirmOrder', () => {
      try {
        confirmOrderMutate(
          {order, orderIntent},
          {
            onSuccess(confirmedOrder) {
              setResult({
                order: confirmedOrder,
                paymentType: orderIntent.paymentType,
                crossSelling: orderIntent.crossSelling,
              })
              setOrder(null)

              window.location.replace(orderPath)
            },
            onError(error) {
              setResult({order, error})
              setOrder(null)
              window.location.replace(orderPath)
            },
          }
        )
      } catch (error) {
        setResult({order, error})
        setOrder(null)
        window.location.replace(orderPath)
      }
    })
  }, [order, setOrder, orderIntent, confirmOrderMutate, setResult, orderPath])

  const retryConfirmation = () => {
    window.location.reload()
  }

  return (
    <Page className="w-full d:w-[1220px] mx-auto px-4 d:px-0">
      <div className="z-[50000] relative block bg-white max-w-full p-8 rounded-xl shadow-md">
        <div className="font-extrabold text-[32px]">Confirming your booking...</div>

        {delayed && (
          <div className="mt-10 text-red-700 text-lg text-center flex flex-col items-center">
            <p className="text-red-700 font-bold">Sorry! Confirming your booking is taking longer than expected.</p>

            {tryAgain ? (
              <>
                <p className="text-sm text-gray-700">
                  You can try again below - don't worry, you will not be charged again.
                </p>
                <button
                  onClick={retryConfirmation}
                  className="mt-4 bg-green-600 block px-4 py-2 text-white rounded-md align-middle"
                >
                  Try again
                </button>
              </>
            ) : (
              <p className="text-sm text-gray-700">
                This can happen during busy times, please wait a few more seconds.
              </p>
            )}
          </div>
        )}
      </div>
    </Page>
  )
}
